import { css } from "@emotion/react";

const globalStyle = css`
  body.modal-open {
    overflow: hidden;
  }
`;

export default globalStyle;
